/* eslint-disable eqeqeq */
import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/styles";
import { Divider, CircularProgress, Card, Button } from "@material-ui/core";
import { HttpRequest } from "../../../utils/httpRequests";
import NavBar from "../../../components/NavBar/NavBar";
import CustomizedSnackbar from "../../../components/CustomizedSnackbar/CustomizedSnackbar";
import C13DeliveryOrdersStatusDashboardFilter from "./chunks/C13DeliveryOrdersStatusDashboardFilter";
import DxGridTable from "../../../components/DxGridTable/DxGridTable";
import { IsEmpty } from "../../../utils/helper";
import C13ChangeDeliveryStatusDialog from "./chunks/C13ChangeDeliveryStatusDialog";
import C13ChangeDeliveryStatusCPRDialog from "./chunks/C13ChangeDeliveryStatusCPRDialog";

import LoginMenu from "../../../components/LoginMenu/LoginMenu";

const useStyles = () => ({
  root: {
    padding: 10,
    margin: "70px 20px",
  },
  topMargin: {
    marginTop: 20,
  },
  button: {
    textTransform: "capitalize",
    marginLeft: 10,
    padding: 10,
    width: 110,
  },
});

class C13DeliveryOrdersStatusDashboard extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      showTableFilter: false,

      isActionLoading: false,

      searchText: "",
      searchTextError: "",

      categoriesData: [
        { id: -1, label: "All" },
        { id: 1, label: "In Progress" },
        { id: 2, label: "Delivered" },
        { id: 3, label: "Payment Received" },
        { id: 7, label: "CPR Recieved" },
        { id: 4, label: "Returned" },
        { id: 5, label: "Un-Delivered" },
        { id: 6, label: "Completed" },

      ],
      categoriesDataLoading: false,
      categoryId: -1,
      categoryIdError: "",

      itemsList: [],

      isOpenChangeStatus: false,
      isOpenCPRChangeStatus: false,
      selectedOrder: {},

      paymentMethodTypeId:"",

      changeStatusId: "",
      changeStatusIdError: "",
      changeCprStatusId: "",
      changeCprStatusIdError: "",


      changeCprIncomeStatusId: "",
      changeCprIncomeStatusIdError: "",


      changeCprJazzCashIncomeStatusId: "",
      changeCprJazzCashIncomeStatusIdError: "",

      changeOtherStatusId: "",
      changeOtherStatusIdError: "",

      changeStatusRemarks: "",
      changeStatusRemarksError: "",

      changeStatusCPRRemarks: "",
      changeStatusCPRRemarksError: "",

      changeStatusLoading: false,

      isOpenSnackbar: false,
      snackbarMessage: "",
      snackbarSeverity: "",

      isLoginMenu: false,
      isReload: true,
    };
  }

  componentDidMount() {
    this.getData(
      "POST",
      "/sales/C13SalesOrderDeliveryTrackingView?categoryId=0",
      null,
      "itemsList",
      "isLoading"
    );
  }

  handleChangeStatusDialogClose = () => {
    this.setState({
      selectedOrder: {},
      isOpenChangeStatus: false,
    });
  };

  handleChangeStatusCPRDialogClose = () => {
    this.setState({
      selectedOrder: {},
      isOpenCPRChangeStatus: false,
    });
  };



  handleChangeStatusDialogOpen = (e, selectedOrder) => {
    e.preventDefault();
    this.setState({
      selectedOrder: selectedOrder,
      isOpenChangeStatus: true,

      changeStatusId:
        selectedOrder.statusId == 2 || selectedOrder.statusId == 3
          ? 1
          : selectedOrder.statusId == 4 || selectedOrder.statusId == 5
            ? 2
            : "",
      changeStatusIdError: "",
      changeOtherStatusId:
        selectedOrder.statusId == 3 ? 1 : selectedOrder.statusId == 4 ? 2 : "",
      changeOtherStatusIdError: "",
      changeStatusRemarks: selectedOrder.deliveryRemarks || "",
      changeStatusRemarksError: "",
    });
  };


  handleChangeStatusCPRDialogOpen = (e, selectedOrder) => {
    e.preventDefault();


    this.setState({
      paymentMethodTypeId: selectedOrder.paymentMethodTypeId ,
      selectedOrder: selectedOrder,
      isOpenCPRChangeStatus: true,

      changeCprStatusId:
        selectedOrder.isCprReceived,
      changeCprIncomeStatusId:
        selectedOrder.isCprIncomeTaxReceived,
      changeCprStatusIdError: "",
        changeCprJazzCashIncomeStatusId:   selectedOrder.isJazzCprReceived,
      changeCprJazzCashIncomeStatusIdError: "",




      changeStatusCPRRemarks: "",
      changeStatusRemarksError: "",
    });
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    const errName = `${name}Error`;
    let errMsg = "";

    switch (name) {
      case "categoryId":
        if (value) {
          const myCategoryId = value < 0 ? 0 : value;
          this.getData(
            "POST",
            `/sales/C13SalesOrderDeliveryTrackingView?categoryId=${myCategoryId}`,
            null,
            "itemsList",
            ""
          );
        }
        break;
      case "changeStatusId":
        this.setState({
          changeOtherStatusId: "",
          changeOtherStatusIdError: "",
        });
        break;


      default:
        break;
    }

    this.setState({
      [name]: value || "",
      [errName]: errMsg,
    });
  };

  handleToggleTableFilter = () => {
    this.setState({ showTableFilter: !this.state.showTableFilter });
  };

  getData = async (
    method = "",
    endpoint = "",
    data = null,
    stateName = "",
    loadingStateName = ""
  ) => {
    let resData = [];
    this.setState({
      [loadingStateName]: true,
    });
    const res = await HttpRequest(
      method,
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}${endpoint}`,
      data,
      "authorizeJson"
    );
    if (res.isSuccess) {
      resData = res.data || [];
    } else {
      if (res.statusCode === 401) {
        this.setState({
          isLoginMenu: true,
        });
      } else {
        this.handleSnackbar(true, res.message, "error");
      }
    }
    this.setState({
      [stateName]: resData,
      [loadingStateName]: false,
    });
  };

  handleSnackbar = (isOpen, message, severity) => {
    this.setState({
      isOpenSnackbar: isOpen,
      snackbarMessage: message,
      snackbarSeverity: severity,
    });
  };

  onCompleteClick = async (row) => {
    if (!IsEmpty(row) && row.id) {
      this.setState({
        isActionLoading: true,
      });
      const data = new FormData();
      data.append("trackingOrderId", row.id);

      const res = await HttpRequest(
        "POST",
        `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/sales/C13SalesOrderDeliveryTrackingStatusSave`,
        data,
        "authorize"
      );

      if (res.isSuccess) {
        this.handleSnackbar(true, "Updated", "success");
        const myCategoryId =
          this.state.categoryId < 0 ? 0 : this.state.categoryId;
        this.getData(
          "POST",
          `/sales/C13SalesOrderDeliveryTrackingView?categoryId=${myCategoryId}`,
          null,
          "itemsList",
          ""
        );
      } else {
        if (res.statusCode === 401) {
          this.setState({
            isLoginMenu: true,
            isReload: false,
          });
        } else {
          this.handleSnackbar(true, res.message, "error");
        }
      }
      this.setState({
        isActionLoading: false,
      });
    } else {
      this.handleSnackbar(true, "Invalid tracking record");
    }
  };


  onCancelClick = async (row) => {
    if (!IsEmpty(row) && row.id) {
      this.setState({
        isActionLoading: true,
      });
      const data = new FormData();
      data.append("trackingOrderId", row.id);

      const res = await HttpRequest(
        "POST",
        `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/sales/C13SalesOrderDeliveryTrackingStatusSave`,
        data,
        "authorize"
      );

      if (res.isSuccess) {
        this.handleSnackbar(true, "Updated", "success");
        const myCategoryId =
          this.state.categoryId < 0 ? 0 : this.state.categoryId;
        this.getData(
          "POST",
          `/sales/C13SalesOrderDeliveryTrackingView?categoryId=${myCategoryId}`,
          null,
          "itemsList",
          ""
        );
      } else {
        if (res.statusCode === 401) {
          this.setState({
            isLoginMenu: true,
            isReload: false,
          });
        } else {
          this.handleSnackbar(true, res.message, "error");
        }
      }
      this.setState({
        isActionLoading: false,
      });
    } else {
      this.handleSnackbar(true, "Invalid tracking record");
    }
  };

  onStatusChangeSaveClick = async (e) => {

    e.preventDefault();
    this.setState({
      changeStatusLoading: true,
    });
    const data = new FormData();
    data.append("consignmentNo", this.state.selectedOrder.consignmentNo);
    data.append("remarks", this.state.changeStatusRemarks);

    let mockTypeId = -1;

    if (!this.state.changeOtherStatusId && this.state.changeStatusId !== "") {
      mockTypeId =
        this.state.changeStatusId == 1
          ? 1
          : this.state.changeStatusId == 2
            ? 4
            : -1;
    } else {
      mockTypeId =
        this.state.changeOtherStatusId == 1
          ? 2
          : this.state.changeOtherStatusId == 2
            ? 3
            : -1;
    }


    data.append("mockTypeId", mockTypeId);

    const res = await HttpRequest(
      "POST",
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/delivery/C13CommonDeliveryPartnerMockJobs`,
      data,
      "authorize"
    );

    if (res.isSuccess) {
      this.handleSnackbar(true, "Updated", "success");
      this.handleChangeStatusDialogClose();
      this.handleChangeStatusCPRDialogClose();
      const myCategoryId =
        this.state.categoryId < 0 ? 0 : this.state.categoryId;
      this.getData(
        "POST",
        `/sales/C13SalesOrderDeliveryTrackingView?categoryId=${myCategoryId}`,
        null,
        "itemsList",
        ""
      );
    } else {
      if (res.statusCode === 401) {
        this.setState({
          isLoginMenu: true,
          isReload: false,
        });
      } else {
        this.handleSnackbar(true, res.message, "error");
      }
    }
    this.setState({
      changeStatusLoading: false,
    });
  };


  onCprStatusChangeSaveClick = async (e) => {
    e.preventDefault();
    this.setState({
      changeStatusLoading: true,
    });
    const data = new FormData();
    data.append("consignmentNo", this.state.selectedOrder.consignmentNo);
    data.append("remarks", this.state.changeStatusRemarks);

    let mockTypeId = -1;
    let CPRReveived = 0;
    let CPRIncomeReceived = 0;
    let isJazzCprReceived=0;

    if (this.state.changeCprStatusId != "") {
      CPRReveived = 1

    }

    if (this.state.changeCprIncomeStatusId != "") {
      CPRIncomeReceived = 1

    }

    if (CPRReveived == 1 && CPRIncomeReceived == 1) {
      mockTypeId = 9;
    } else {
      if (CPRReveived == 1) {
        mockTypeId = 7
      } else if (CPRIncomeReceived == 1) {
        mockTypeId = 8
      }
    }


     if (this.state.changeCprJazzCashIncomeStatusId != "") {
      isJazzCprReceived = 1
       mockTypeId = 10
     }





    data.append("mockTypeId", mockTypeId);

    const res = await HttpRequest(
      "POST",
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/delivery/C13CommonDeliveryPartnerMockJobs`,
      data,
      "authorize"
    );

    if (res.isSuccess) {
      this.handleSnackbar(true, "Updated", "success");
      this.handleChangeStatusDialogClose();
      this.handleChangeStatusCPRDialogClose();
      const myCategoryId =
        this.state.categoryId < 0 ? 0 : this.state.categoryId;
      this.getData(
        "POST",
        `/sales/C13SalesOrderDeliveryTrackingView?categoryId=${myCategoryId}`,
        null,
        "itemsList",
        ""
      );
    } else {
      if (res.statusCode === 401) {
        this.setState({
          isLoginMenu: true,
          isReload: false,
        });
      } else {
        this.handleSnackbar(true, res.message, "error");
      }
    }
    this.setState({
      changeStatusLoading: false,
    });
  };

  render() {
    const { classes } = this.props;
    const tableColumnExtensions = [
      { columnName: "orderId", width: 100 },
      { columnName: "customerLabel", wordWrapEnabled: true },
      { columnName: "destinationAddressLabel", wordWrapEnabled: true },
      { columnName: "orderWeightLabel", wordWrapEnabled: true },
      { columnName: "totalAmountLabel", wordWrapEnabled: true },
      { columnName: "ckDeliveryChargesLabel", wordWrapEnabled: true },
      { columnName: "ckReceivedDeliveryChargesLabel", wordWrapEnabled: true },
      { columnName: "tcsDeliveryChargesLabel", wordWrapEnabled: true },
      { columnName: "tcsReceivedDeliveryChargesLabel", wordWrapEnabled: true },

      { columnName: "deliveryPartnerLabel", wordWrapEnabled: true },
      { columnName: "consignmentNo", wordWrapEnabled: true },
      { columnName: "bookingDateLabel", wordWrapEnabled: true },
      { columnName: "deliveryDateLabel", wordWrapEnabled: true },
      { columnName: "paymentDateLabel", wordWrapEnabled: true },
      { columnName: "statusLabel", wordWrapEnabled: true },
      { columnName: "action", wordWrapEnabled: true },
    ];
    const columns = [
      { name: "orderId", title: "Order #" },
      { name: "customerLabel", title: "Customer" },
      { name: "destinationAddressLabel", title: "Cus. Address" },
      { name: "orderWeightLabel", title: "Order Weight" },
      { name: "totalAmountLabel", title: "Total Amount" },
      { name: "ckDeliveryChargesLabel", title: "CK Delivery Charges" },
      { name: "ckReceivedDeliveryChargesLabel", title: "CK After Delivery Charges" },
      { name: "tcsDeliveryChargesLabel", title: "TCS Delivery Charges" },
      { name: "tcsReceivedDeliveryChargesLabel", title: "TCS After Delivery Charges" },
      { name: "deliveryPartnerLabel", title: "Delivery Partner" },
      { name: "consignmentNo", title: "Consignment #" },
      { name: "bookingDateLabel", title: "Booking Date" },
      { name: "deliveryDateLabel", title: "Delivery Date" },
      { name: "paymentDateLabel", title: "Payment Date" },
      { name: "statusLabel", title: "Status" },
      {
        name: "action",
        title: "Action",
        getCellValue: (row) => {
          return (
            <div>

              <Button
                onClick={() => this.onCompleteClick(row)}
                disabled={(row.statusId != 3) || this.state.isActionLoading}
                color="primary"
                size="small"
                title="Complete"
                variant="contained"
                fullWidth
                style={{
                  fontSize: 11,
                  textTransform: "capitalize",
                  marginBottom: 10,
                }}
              >
                {" "}
                Complete{" "}
              </Button>
              {row.deliveryPartnerId == 3 && (
                <Button
                  onClick={(e) => this.handleChangeStatusDialogOpen(e, row)}
                  disabled={
                    row.statusId == 6 ||
                    row.deliveryPartnerId != 3 ||
                    this.state.isActionLoading
                  }
                  color="primary"
                  size="small"
                  title="Change delivery status"
                  variant="contained"
                  fullWidth
                  style={{
                    fontSize: 11,
                    textTransform: "capitalize",
                  }}
                >
                  Change Status
                </Button>
              )}

              {(row.deliveryPartnerId == 2 && row.isDisputed == 0) && (
                <Button
                  onClick={(e) => this.handleChangeStatusCPRDialogOpen(e, row)}
                  disabled={
                    row.statusId != 3 || (row.isCprIncomeTaxReceived == 1 && row.isCprReceived == 1) ||

                    this.state.isActionLoading
                  }
                  color="primary"
                  size="small"
                  title="Change delivery status"
                  variant="contained"
                  fullWidth
                  style={{
                    fontSize: 11,
                    textTransform: "capitalize",
                  }}
                >
                  CPR Received
                </Button>
              )}


            </div>
          );
        },
      },
    ];
    return (
      <Fragment>
        <LoginMenu
          reload={this.state.isReload}
          open={this.state.isLoginMenu}
          handleClose={() => this.setState({ isLoginMenu: false })}
        />
        <CustomizedSnackbar
          isOpen={this.state.isOpenSnackbar}
          message={this.state.snackbarMessage}
          severity={this.state.snackbarSeverity}
          handleCloseSnackbar={() => this.handleSnackbar(false, "", "")}
          autoHideDuration={3000}
        />
        <C13ChangeDeliveryStatusDialog
          open={this.state.isOpenChangeStatus}
          handleClose={() => this.handleChangeStatusDialogClose()}
          state={this.state}
          onHandleChange={this.handleChange}
          onSaveClick={(e) => this.onStatusChangeSaveClick(e)}
        />

        <C13ChangeDeliveryStatusCPRDialog
          open={this.state.isOpenCPRChangeStatus}
          handleClose={() => this.handleChangeStatusCPRDialogClose()}
          state={this.state}
          onHandleChange={this.handleChange}
          onSaveClick={(e) => this.onCprStatusChangeSaveClick(e)}
        />
        <NavBar isAuthorize />
        <div className={classes.root}>
          <div className={classes.topMargin}>
            <C13DeliveryOrdersStatusDashboardFilter
              state={this.state}
              handleChange={(e) => this.handleChange(e)}
              handleToggleTableFilter={() => this.handleToggleTableFilter()}
              onNewItemButtonClick={() => this.onNewItemButtonClick()}
              getOrdersData={() => {
                const myCategoryId =
                  this.state.categoryId < 0 ? 0 : this.state.categoryId;
                this.getData(
                  "POST",
                  `/sales/C13SalesOrderDeliveryTrackingView?categoryId=${myCategoryId}&isRefresh=1`,
                  null,
                  "itemsList",
                  "isLoading"
                );
              }}
            />
          </div>
          <Divider style={{ marginTop: 10, marginBottom: 30 }} />
          <Card className={classes.topMargin}>
            {!this.state.isLoading ? (
              <DxGridTable
                data={this.state.itemsList}
                columns={columns}
                showFilter={this.state.showTableFilter}
                isLoading={this.state.isLoading}
                tableColumnExtensions={tableColumnExtensions}
              />
            ) : (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: 50,
                  width: "100%",
                  overflow: "hidden",
                  height: "90px",
                }}
              >
                <CircularProgress />
              </div>
            )}
          </Card>
        </div>
      </Fragment>
    );
  }
}

C13DeliveryOrdersStatusDashboard.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(useStyles)(C13DeliveryOrdersStatusDashboard);
